import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.00078 18.8495C11.4147 17.1651 17.9999 13.6384 17.9999 11.5C17.9999 9.36162 11.4147 5.83497 8.00078 4.1504C7.08018 3.69614 6 4.32627 6 5.29868V17.7013C6 18.6738 7.08018 19.3039 8.00078 18.8495Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.00078 18.8495C11.4147 17.1651 17.9999 13.6384 17.9999 11.5C17.9999 9.36162 11.4147 5.83497 8.00078 4.1504C7.08018 3.69614 6 4.32627 6 5.29868V17.7013C6 18.6738 7.08018 19.3039 8.00078 18.8495Z",
		stroke: "currentColor",
		strokeWidth: 1.0725,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPlay;
